<template>
    <div class="menu-sidebar--sublevel" :class="active ? 'menu-sidebar--sublevel--active' : ''" v-if="items">
        <h3 class="menu-sidebar--sublevel-title text-left m-0">
            <button class="chevron btn" @click="$emit('close')">
                <svg width="10" xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 7.778 12.728" id="gla--backwards">
                    <path d="M7.072 12.02L1.415 6.363 7.072.706" 
                        fill="none" stroke="#ffffff" 
                        stroke-width="2">
                    </path>
                </svg>
            </button>
            
            {{ title }}
        </h3>

        <div class="menu-sidebar--main-items" :style="{height: menuHeight-80+'px'}">
            <MenuItem v-for="(item, index) in items" :key="index" :item="item" :menu-height="menuHeight"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'SubMenu',
        props: {
            title: {
                type: String,
                required: true
            },
            items: {
                type: Object|Array,
                required: true
            },
            active: {
                type: Boolean
            },
            menuHeight: {
                type: Number
            }
        }
    }
</script>